import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import PHOTO4 from './PHOTO4.jpg';
import PHOTO5 from './PHOTO5.jpg';
import { SlideParagraph } from '../slide-paragraph';

export const AMKProfiles2 = React.memo((): React.ReactElement => {
  return (
    <Grid container direction="column" className={styles.container}>
      <Grid item sx={{ paddingTop: '0px !important' }}>
        <Grid
          container
          direction="row"
          spacing={2}
          sx={{ paddingBottom: '12px' }}
        >
          <Grid item xs={12} md={3}>
            <Grid item sx={{ width: '100%', height: '100%' }}>
              <img
                src={PHOTO4}
                alt="PHOTO4"
                style={{ width: '100%', height: 'auto' }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <SlideParagraph style={{ fontWeight: '600' }}>
              Nick Carcione, CFA
            </SlideParagraph>
            <SlideParagraph style={{ fontWeight: '500', marginBottom: '6px' }}>
              Senior Analyst, Investment Consulting
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px', marginBottom: '6px' }}>
              Nick is responsible for developing practice-based investment
              solutions in consultation with advisors and helping to expand the
              firm’s thought leadership efforts.
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px' }}>
              Nick has over 8 years’ experience and joined AssetMark in 2019
              through the acquisition of Global Financial Private Capital
              (GFPC). Prior to joining the investment consulting team, Nick
              worked within the sales organization as a resource for advisors
              building investment solutions for their clients.
            </SlideParagraph>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={2}
          sx={{ paddingBottom: '12px' }}
        >
          <Grid item xs={12} md={3}>
            <Grid item>
              <img
                src={PHOTO5}
                alt="PHOTO5"
                style={{ width: '100%', height: 'auto' }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <SlideParagraph style={{ fontWeight: '600' }}>
              Julio Bedolla, MBA
            </SlideParagraph>
            <SlideParagraph style={{ fontWeight: '500', marginBottom: '6px' }}>
              Analyst, Investment Consulting
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px', marginBottom: '6px' }}>
              Julio is responsible in supporting the development of
              practice-based investment solutions, collaborating with advisors
              and their practices to create scalable investment strategies.
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px' }}>
              Julio has over 7 years’ experience and joined AssetMark in 2024.
              Prior to joining AssetMark, Julio worked as a wealth manager with
              RIAs providing investment & portfolio analysis, most recently at
              Lourdmurray. Previously he held various investment related roles
              at Dimensional Fund Advisors, Capital Group, and Ernst & Young.
            </SlideParagraph>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
